import React from 'react';
import useWithStore from "@/Hooks/useWithStore";
import CatalogCard from "@/Components/Site/CatalogCard";
import {isDesktop, isMobile, scrollToElement} from "@/Helpers/Function";
import Svg from "@/Components/Svg";
import {withViewItemBatcher} from "@/Context/ViewItemBatcherContext";
import '@/Pages/Collections/scss/line.scss';

class Line extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            videoSvg: false,
            videoPlayPauseFlag: true,
            videoNorthernLightsVolumeSvg: true,
            // Сколько показывать карточек при загрузке
            cardOneListCount: 10,
            cardTwoListCount: 10,
            cardThreeListCount: 10,
            cardFourListCount: 10,
            cardFiveListCount: 10,
            cardSixListCount: 10,
            cardSevenListCount: 10,
            // Сколько прибавлять карточек (показать еще)
            cardOneListCountAdd: 10,
            cardTwoListCountAdd: 10,
            cardThreeListCountAdd: 10,
            cardFourListCountAdd: 10,
            cardFiveListCountAdd: 10,
            cardSixListCountAdd: 10,
            cardSevenListCountAdd: 10,
            // Количество активных карточек при старте
            cardOneActive: [],
            cardTwoActive: [],
            cardThreeActive: [],
            cardFourActive: [],
            cardFiveActive: [],
            cardSixActive: [],
            cardSevenActive: [],
            // Флаги
            setOne: false,
            setTwo: false,
            setThree: false,
            setFour: false,
            setFive: false,
            setSex: false,
            setSeven: false,
        };
        this.videoRef = React.createRef();
        this.setOneRef = React.createRef();
        this.setTwoRef = React.createRef();
        this.setThreeRef = React.createRef();
        this.setFourRef = React.createRef();
        this.setFiveRef = React.createRef();
        this.setSixRef = React.createRef();
        this.setSevenRef = React.createRef();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.videoRef.current !== null) {
            const video = this.videoRef.current;
            video.onended = (e) => {
                video.muted = true;
                this.setState({
                    videoSvg: true,
                    videoNorthernLightsVolumeSvg: true
                })
            };
        }
    }

    videoTimer = () => setTimeout(() => {
        this.setState({videoPlayPauseFlag: false})
    }, 3000);

    /**
     * Управление звуком
     */
    mediaChangeVolume = () => {
        try {
            const video = this.videoRef.current;
            if (video.muted) {
                video.muted = false;
                this.setState({videoNorthernLightsVolumeSvg: false})
            } else {
                video.muted = true;
                this.setState({videoNorthernLightsVolumeSvg: true})
            }
        } catch (e) {
            console.log('e', e);
        }
    }

    /**
     * Убираем кнопку паузы на мобилке
     */
    mediaChangePlayPause = () => {
        try {
            if (!isDesktop()) {
                clearInterval(this.videoTimerId);
                if (!this.state.videoPlayPauseFlag) {
                    this.setState({videoPlayPauseFlag: true})
                }
                this.videoTimerId = this.videoTimer();
            }
        } catch (e) {
            console.log('e', e);
        }
    }

    /**
     * Воспроизведение / пауза видео
     */
    mediaChange = () => {
        try {
            const video = this.videoRef.current;
            if (video.paused) {
                video.play();
                this.setState({videoSvg: false})
            } else {
                video.pause();
                this.setState({videoSvg: true})
            }
            video.onended = (e) => {
                this.setState({videoSvg: true})
            };
        } catch (e) {
            console.log('e', e);
        }
    }

    setOpen = (set, ref) => {
        if (!this.state[set]) {
            this.setState({[set]: true});
        }
        const options = {block: "start", inline: "center", behavior: "smooth"};
        setTimeout(() => {
            scrollToElement(this[ref].current, options);
        }, 10)
    }

    // Добавляем карточки при клике на (показать еще)
    showMore = (set, setAdd) => {
        this.setState({
            [set]: this.state[set] + this.state[setAdd],
        });
    }

    // Показать еще текст кнопки
    showMoreMessage = (count, setAdd) => {
        if (this.state[setAdd] < count) {
            return `Показать еще ${this.state[setAdd]} из ${count}`;
        } else {
            return `Показать еще ${count}`;
        }
    };


    render() {
        const {collectionDetailedData = {}, uploadUrl = '', registerView} = this.props;

        const {
            setOne,
            setTwo,
            setThree,
            setFour,
            setFive,
            setSix,
            setSeven,
            videoSvg,
            videoPlayPauseFlag,
            videoNorthernLightsVolumeSvg
        } = this.state;

        let offset = 0;

        // Получаем массив с нужным количеством карточек при старте
        this.state.cardOneActive = collectionDetailedData.platinaOne.slice(0, this.state.cardOneListCount);
        const countOne = collectionDetailedData.platinaOne.length - this.state.cardOneActive.length;
        const dataOne = this.state.cardOneActive.map((product, i) => {
            return <CatalogCard
                key={product.id}
                el={product}
                {...this.props}
                index={offset + i + 1}
                registerView={registerView}
            />
        });
        offset += collectionDetailedData.platinaOne.length;
        this.state.cardTwoActive = collectionDetailedData.platinaTwo.slice(0, this.state.cardTwoListCount);
        const countTwo = collectionDetailedData.platinaTwo.length - this.state.cardTwoActive.length;
        const dataTwo = this.state.cardTwoActive.map((product, i) => {
            return <CatalogCard
                key={product.id}
                el={product}
                {...this.props}
                index={offset + i + 1}
                registerView={registerView}
            />
        });
        offset += collectionDetailedData.platinaTwo.length;
        this.state.cardThreeActive = collectionDetailedData.platinaThree.slice(0, this.state.cardThreeListCount);
        const countThree = collectionDetailedData.platinaThree.length - this.state.cardThreeActive.length;
        const dataThree = this.state.cardThreeActive.map((product, i) => {
            return <CatalogCard
                key={product.id}
                el={product}
                {...this.props}
                index={offset + i + 1}
                registerView={registerView}
            />
        });
        offset += collectionDetailedData.platinaThree.length;
        this.state.cardFourActive = collectionDetailedData.platinaFour.slice(0, this.state.cardFourListCount);
        const countFour = collectionDetailedData.platinaFour.length - this.state.cardFourActive.length;
        const dataFour = this.state.cardFourActive.map((product, i) => {
            return <CatalogCard
                key={product.id}
                el={product}
                {...this.props}
                index={offset + i + 1}
                registerView={registerView}
            />
        });
        offset += collectionDetailedData.platinaFour.length;
        this.state.cardFiveActive = collectionDetailedData.platinaFive.slice(0, this.state.cardFiveListCount);
        const countFive = collectionDetailedData.platinaFive.length - this.state.cardFiveActive.length;
        const dataFive = this.state.cardFiveActive.map((product, i) => {
            return <CatalogCard
                key={product.id}
                el={product}
                {...this.props}
                index={offset + i + 1}
                registerView={registerView}
            />
        });
        offset += collectionDetailedData.platinaFive.length;
        this.state.cardSixActive = collectionDetailedData.platinaSix.slice(0, this.state.cardSixListCount);
        const countSix = collectionDetailedData.platinaSix.length - this.state.cardSixActive.length;
        const dataSix = this.state.cardSixActive.map((product, i) => {
            return <CatalogCard
                key={product.id}
                el={product}
                {...this.props}
                index={offset + i + 1}
                registerView={registerView}
            />
        });
        offset += collectionDetailedData.platinaSix.length;
        this.state.cardSevenActive = collectionDetailedData.platinaSeven.slice(0, this.state.cardSevenListCount);
        const countSeven = collectionDetailedData.platinaSeven.length - this.state.cardSevenActive.length;
        const dataSeven = this.state.cardSevenActive.map((product, i) => {
            return <CatalogCard
                key={product.id}
                el={product}
                {...this.props}
                index={offset + i + 1}
                registerView={registerView}
            />
        });
        offset += collectionDetailedData.platinaSeven.length;

        return <section className={`section`}>
            <div className={`collections-lp`}>
                <div className={`container`}>
                    <div className={`svgLineTop`}>
                        <Svg id={`platina-line`} className={`svg__platina-line`} />
                    </div>
                    <div className={`line-wrapper`}>
                        <div className={`line-wrapper__video-main`}>
                            <video ref={this.videoRef}
                                   autoPlay
                                   muted={`muted`}
                                   preload={`none`}
                                   width={`100%`}
                                   poster={isMobile() ? `/storage/img/collections/line/video-poster-mobile.jpg` : '/storage/img/collections/line/video-poster.jpg'}
                            >
                                {isMobile() ?
                                    <>
                                        <source
                                            src={`${uploadUrl}/media/video/collections/line/LINE_1x1_768_2.5.mp4`}
                                            type={`video/mp4`} />
                                        <source
                                            src={`${uploadUrl}/media/video/collections/line/LINE_1x1_768_2.5.webm`}
                                            type={`video/webm`} />
                                        <source
                                            src={`${uploadUrl}/media/video/collections/line/LINE_1x1_768_2.5.ogg`}
                                            type={`video/ogg`} />
                                    </>
                                    :
                                    <>
                                        <source
                                            src={`${uploadUrl}/media/video/collections/line/LINE_16x9_1330_2.5mbps.mp4`}
                                            type={`video/mp4`} />
                                        <source
                                            src={`${uploadUrl}/media/video/collections/line/LINE_16x9_1330_2.5mbps.webm`}
                                            type={`video/webm`} />
                                        <source
                                            src={`${uploadUrl}/media/video/collections/line/LINE_16x9_1330_2.5mbps.ogg`}
                                            type={`video/ogg`} />
                                    </>
                                }
                            </video>
                            <div className={`video-control`}
                                 onClick={() => this.mediaChangePlayPause()}>
                                {videoSvg ?
                                    <>
                                        <div className={`gg-play-button`}
                                             onClick={() => this.mediaChange()}></div>
                                    </>
                                    :
                                    <>
                                        {videoPlayPauseFlag && (
                                            <div className={`gg-pause-button`}
                                                 onClick={() => this.mediaChange()}></div>
                                        )}
                                    </>
                                }
                                <div className={`volume`}
                                     onClick={() => this.mediaChangeVolume()}>
                                    {videoNorthernLightsVolumeSvg ?
                                        <Svg id={`volumeOffOutlinedIcon`} className={`svg__muted-off`} />
                                        :
                                        <Svg id={`volumeDownOutlinedIcon`} className={`svg__muted-on`} />
                                    }
                                </div>
                            </div>
                        </div>
                        <h1 className={`h1 h1__one`}>
                            Украшения коллекции PLATINA LINE&nbsp;&mdash; стильный элемент образа.
                        </h1>
                        <div className={`line-wrapper__description line-wrapper__description_one`}>
                            <p>
                                И&nbsp;яркий акцент, который дарит чувство свободы. Возможность
                                экспериментировать. Желание самой формировать своё настоящее и&nbsp;выражать
                                своё настроение!
                            </p>
                        </div>
                        <div className={`line-wrapper__description line-wrapper__description_two`}>
                            <p>
                                Коллекция включает семь сетов украшений. Таких разных. Но&nbsp;их&nbsp;так легко
                                миксовать друг с&nbsp;другом! С&nbsp;ними просто создать любой образ. Быть
                                стильной в&nbsp;любой ситуации. PLATINA LINE&nbsp;&mdash; когда важен каждый
                                элемент!
                            </p>
                        </div>
                        <div className={`line-wrapper__set line-wrapper__set_one`}>
                            <picture>
                                <source type="image/webp"
                                        srcSet={`/storage/img/collections/line/duet-form-mobile.webp`}
                                        media="(max-width: 767px)"
                                />
                                <source type="image/webp"
                                        srcSet={`/storage/img/collections/line/duet-form.webp`}
                                />
                                <source srcSet={`/storage/img/collections/line/duet-form-mobile.jpg`}
                                        media="(max-width: 767px)"
                                />
                                <img src={`/storage/img/collections/line/duet-form.jpg`}
                                     alt={`Дуэт форм`}
                                     title={`Дуэт форм`}
                                     loading="lazy"
                                     width={isMobile() ? "767" : "1500"}
                                     height={isMobile() ? "790" : "790"}
                                />
                            </picture>
                            <div
                                className={`line-wrapper__set-content line-wrapper__set-content_odd line-wrapper__set-content_one`}>
                                <p className={`set`}>Сет</p>
                                <p className={`title`}>&laquo;Дуэт форм&raquo;</p>
                                <p className={`text`}>
                                    Совершенство геометрических линий. Трендовый дизайн с&nbsp;акцентом
                                    на&nbsp;шарах. Универсальный характер&nbsp;&mdash; украшения легко подходят
                                    к&nbsp;любому стилю и&nbsp;настроению.
                                </p>
                                {collectionDetailedData.platinaOne.length !== 0 && (
                                    <div className={`btn btn__default btn__platina-line`}
                                         onClick={() => this.setOpen('setOne', 'setOneRef')}>
                                        Украшения сета
                                        <Svg id={`arrows-right`} className={`svg__arrow-right-one`} />
                                    </div>
                                )}
                            </div>
                        </div>
                        {setOne && (
                            <>
                                <div className={`cardAll cardAll__platinaLine`}
                                     ref={this.setOneRef}>
                                    <div className={`cardAll__catalog`}>
                                        {dataOne}
                                    </div>
                                </div>
                                {countOne !== 0 && (
                                    <div className={`buttons buttons__showMore`}>
                                        <div className={`btn btn__showMore`}
                                             onClick={() => this.showMore('cardOneListCount', 'cardOneListCountAdd')}>
                                            {this.showMoreMessage(countOne, 'cardOneListCountAdd')}
                                        </div>
                                    </div>
                                )}
                            </>
                        )}
                        <div className={`line-wrapper__set line-wrapper__set_two`}>
                            <picture>
                                <source type="image/webp"
                                        srcSet={`/storage/img/collections/line/stilnaya-fantaziya-mobile.webp`}
                                        media="(max-width: 767px)"
                                />
                                <source type="image/webp"
                                        srcSet={`/storage/img/collections/line/stilnaya-fantaziya.webp`}
                                />
                                <source srcSet={`/storage/img/collections/line/stilnaya-fantaziya-mobile.jpg`}
                                        media="(max-width: 767px)"
                                />
                                <img src={`/storage/img/collections/line/stilnaya-fantaziya.jpg`}
                                     alt={`Стильная фантазия`}
                                     title={`Стильная фантазия`}
                                     loading="lazy"
                                     width={isMobile() ? "767" : "1500"}
                                     height={isMobile() ? "790" : "790"}
                                />
                            </picture>
                            <div
                                className={`line-wrapper__set-content line-wrapper__set-content_even line-wrapper__set-content_two`}>
                                <p className={`set`}>Сет</p>
                                <p className={`title`}>&laquo;Стильная фантазия&raquo;</p>
                                <p className={`text`}>
                                    Эффектное сочетание геометрических форм&nbsp;&mdash; шаров, цепей, линий.
                                    Плавность силуэтов в&nbsp;каждом штрихе. Украшения, с&nbsp;которыми
                                    чувствуешь себя стильной и&nbsp;современной!
                                </p>
                                {collectionDetailedData.platinaTwo.length !== 0 && (
                                    <div className={`btn btn__default btn__platina-line`}
                                         onClick={() => this.setOpen('setTwo', 'setTwoRef')}>
                                        Украшения сета
                                        <Svg id={`arrows-right`} className={`svg__arrow-right-one`} />
                                    </div>
                                )}
                            </div>
                        </div>
                        {setTwo && (
                            <>
                                <div className={`cardAll cardAll__platinaLine`}
                                     ref={this.setTwoRef}>
                                    <div className={`cardAll__catalog`}>
                                        {dataTwo}
                                    </div>
                                </div>
                                {countTwo !== 0 && (
                                    <div className={`buttons buttons__showMore`}>
                                        <div className={`btn btn__showMore`}
                                             onClick={() => this.showMore('cardTwoListCount', 'cardTwoListCountAdd')}>
                                            {this.showMoreMessage(countTwo, 'cardTwoListCountAdd')}
                                        </div>
                                    </div>
                                )}
                            </>
                        )}
                        <div className={`line-wrapper__set line-wrapper__set_three`}>
                            <picture>
                                <source type="image/webp"
                                        srcSet={`/storage/img/collections/line/kontrasty-mobile.webp`}
                                        media="(max-width: 767px)"
                                />
                                <source type="image/webp"
                                        srcSet={`/storage/img/collections/line/kontrasty.webp`}
                                />
                                <source srcSet={`/storage/img/collections/line/kontrasty-mobile.jpg`}
                                        media="(max-width: 767px)"
                                />
                                <img src={`/storage/img/collections/line/kontrasty.jpg`}
                                     alt={`Контрасты`}
                                     title={`Контрасты`}
                                     loading="lazy"
                                     width={isMobile() ? "767" : "1500"}
                                     height={isMobile() ? "790" : "624"}
                                />
                            </picture>
                            <div
                                className={`line-wrapper__set-content line-wrapper__set-content_odd line-wrapper__set-content_three`}>
                                <p className={`set`}>Сет</p>
                                <p className={`title`}>&laquo;контрасты&raquo;</p>
                                <p className={`text`}>
                                    Эффектный дизайн в&nbsp;стиле геометрия. Асимметричность силуэтов.
                                    Украшения, которые станут стильными акцентами в&nbsp;образе!
                                </p>
                                {collectionDetailedData.platinaThree.length !== 0 && (
                                    <div className={`btn btn__default btn__platina-line`}
                                         onClick={() => this.setOpen('setThree', 'setThreeRef')}>
                                        Украшения сета
                                        <Svg id={`arrows-right`} className={`svg__arrow-right-one`} />
                                    </div>
                                )}
                            </div>
                        </div>
                        {setThree && (
                            <>
                                <div className={`cardAll cardAll__platinaLine`}
                                     ref={this.setThreeRef}>
                                    <div className={`cardAll__catalog`}>
                                        {dataThree}
                                    </div>
                                </div>
                                {countThree !== 0 && (
                                    <div className={`buttons buttons__showMore`}>
                                        <div className={`btn btn__showMore`}
                                             onClick={() => this.showMore('cardThreeListCount', 'cardThreeListCountAdd')}>
                                            {this.showMoreMessage(countThree, 'cardThreeListCountAdd')}
                                        </div>
                                    </div>
                                )}
                            </>
                        )}
                        <div className={`line-wrapper__set line-wrapper__set_four`}>
                            <picture>
                                <source type="image/webp"
                                        srcSet={`/storage/img/collections/line/siyanie-mobile.webp`}
                                        media="(max-width: 767px)"
                                />
                                <source type="image/webp"
                                        srcSet={`/storage/img/collections/line/siyanie.webp`}
                                />
                                <source srcSet={`/storage/img/collections/line/siyanie-mobile.jpg`}
                                        media="(max-width: 767px)"
                                />
                                <img src={`/storage/img/collections/line/siyanie.jpg`}
                                     alt={`Сияние`}
                                     title={`Сияние`}
                                     loading="lazy"
                                     width={isMobile() ? "767" : "1500"}
                                     height={isMobile() ? "790" : "624"}
                                />
                            </picture>
                            <div
                                className={`line-wrapper__set-content line-wrapper__set-content_even line-wrapper__set-content_four`}>
                                <p className={`set`}>Сет</p>
                                <p className={`title`}>&laquo;Сияние&raquo;</p>
                                <p className={`text`}>
                                    Стильный дуэт оттенков металла. Безупречность плавных линий. Украшения,
                                    с&nbsp;которыми легко создать стильный образ!
                                </p>
                                {collectionDetailedData.platinaFour.length !== 0 && (
                                    <div className={`btn btn__default btn__platina-line`}
                                         onClick={() => this.setOpen('setFour', 'setFourRef')}>
                                        Украшения сета
                                        <Svg id={`arrows-right`} className={`svg__arrow-right-one`} />
                                    </div>
                                )}
                            </div>
                        </div>
                        {setFour && (
                            <>
                                <div className={`cardAll cardAll__platinaLine`}
                                     ref={this.setFourRef}>
                                    <div className={`cardAll__catalog`}>
                                        {dataFour}
                                    </div>
                                </div>
                                {countFour !== 0 && (
                                    <div className={`buttons buttons__showMore`}>
                                        <div className={`btn btn__showMore`}
                                             onClick={() => this.showMore('cardFourListCount', 'cardFourListCountAdd')}>
                                            {this.showMoreMessage(countFour, 'cardFourListCountAdd')}
                                        </div>
                                    </div>
                                )}
                            </>
                        )}
                        <div className={`line-wrapper__set line-wrapper__set_five`}>
                            <picture>
                                <source type="image/webp"
                                        srcSet={`/storage/img/collections/line/energiya-mobile.webp`}
                                        media="(max-width: 767px)"
                                />
                                <source type="image/webp"
                                        srcSet={`/storage/img/collections/line/energiya.webp`}
                                />
                                <source srcSet={`/storage/img/collections/line/energiya-mobile.jpg`}
                                        media="(max-width: 767px)"
                                />
                                <img src={`/storage/img/collections/line/energiya.jpg`}
                                     alt={`Энергия`}
                                     title={`Энергия`}
                                     loading="lazy"
                                     width={isMobile() ? "767" : "1500"}
                                     height={isMobile() ? "790" : "624"}
                                />
                            </picture>
                            <div
                                className={`line-wrapper__set-content line-wrapper__set-content_odd line-wrapper__set-content_five`}>
                                <p className={`set`}>Сет</p>
                                <p className={`title`}>&laquo;энергия&raquo;</p>
                                <p className={`text`}>
                                    В&nbsp;центре внимания&nbsp;&mdash; идеальная форма круга. Его совершенство.
                                    Его значимость как непрерывности энергии и&nbsp;гармонии жизни. Украшения
                                    с&nbsp;ярким и&nbsp;динамичным характером!
                                </p>
                                {collectionDetailedData.platinaFive.length !== 0 && (
                                    <div className={`btn btn__default btn__platina-line`}
                                         onClick={() => this.setOpen('setFive', 'setFiveRef')}>
                                        Украшения сета
                                        <Svg id={`arrows-right`} className={`svg__arrow-right-one`} />
                                    </div>
                                )}
                            </div>
                        </div>
                        {setFive && (
                            <>
                                <div className={`cardAll cardAll__platinaLine`}
                                     ref={this.setFiveRef}>
                                    <div className={`cardAll__catalog`}>
                                        {dataFive}
                                    </div>
                                </div>
                                {countFive !== 0 && (
                                    <div className={`buttons buttons__showMore`}>
                                        <div className={`btn btn__showMore`}
                                             onClick={() => this.showMore('cardFiveListCount', 'cardFiveListCountAdd')}>
                                            {this.showMoreMessage(countFive, 'cardFiveListCountAdd')}
                                        </div>
                                    </div>
                                )}
                            </>
                        )}
                        <div className={`line-wrapper__set line-wrapper__set_six`}>
                            <picture>
                                <source type="image/webp"
                                        srcSet={`/storage/img/collections/line/sovershenstvo-mobile.webp`}
                                        media="(max-width: 767px)"
                                />
                                <source type="image/webp"
                                        srcSet={`/storage/img/collections/line/sovershenstvo.webp`}
                                />
                                <source srcSet={`/storage/img/collections/line/sovershenstvo-mobile.jpg`}
                                        media="(max-width: 767px)"
                                />
                                <img src={`/storage/img/collections/line/sovershenstvo.jpg`}
                                     alt={`Совершенство`}
                                     title={`Совершенство`}
                                     loading="lazy"
                                     width={isMobile() ? "767" : "1500"}
                                     height={isMobile() ? "790" : "624"}
                                />
                            </picture>
                            <div
                                className={`line-wrapper__set-content line-wrapper__set-content_even line-wrapper__set-content_six`}>
                                <p className={`set`}>Сет</p>
                                <p className={`title`}>&laquo;Совершенство&raquo;</p>
                                <p className={`text`}>
                                    Главный акцент на&nbsp;золотых сферах&nbsp;&mdash; символах совершенства.
                                    Ощущение объёма и&nbsp;лёгкости. Украшения для любой ситуации!
                                </p>
                                {collectionDetailedData.platinaSix.length !== 0 && (
                                    <div className={`btn btn__default btn__platina-line`}
                                         onClick={() => this.setOpen('setSix', 'setSixRef')}>
                                        Украшения сета
                                        <Svg id={`arrows-right`} className={`svg__arrow-right-one`} />
                                    </div>
                                )}
                            </div>
                        </div>
                        {setSix && (
                            <>
                                <div className={`cardAll cardAll__platinaLine`}
                                     ref={this.setSixRef}>
                                    <div className={`cardAll__catalog`}>
                                        {dataSix}
                                    </div>
                                </div>
                                {countSix !== 0 && (
                                    <div className={`buttons buttons__showMore`}>
                                        <div className={`btn btn__showMore`}
                                             onClick={() => this.showMore('cardSixListCount', 'cardSixListCountAdd')}>
                                            {this.showMoreMessage(countSix, 'cardSixListCountAdd')}
                                        </div>
                                    </div>
                                )}
                            </>
                        )}
                        <div className={`line-wrapper__set line-wrapper__set_seven`}>
                            <picture>
                                <source type="image/webp"
                                        srcSet={`/storage/img/collections/line/nastroenie-mobile.webp`}
                                        media="(max-width: 767px)"
                                />
                                <source type="image/webp"
                                        srcSet={`/storage/img/collections/line/nastroenie.webp`}
                                />
                                <source srcSet={`/storage/img/collections/line/nastroenie-mobile.jpg`}
                                        media="(max-width: 767px)"
                                />
                                <img src={`/storage/img/collections/line/nastroenie.jpg`}
                                     alt={`Настроение`}
                                     title={`Настроение`}
                                     loading="lazy"
                                     width={isMobile() ? "767" : "1500"}
                                     height={isMobile() ? "790" : "624"}
                                />
                            </picture>
                            <div
                                className={`line-wrapper__set-content line-wrapper__set-content_odd line-wrapper__set-content_seven`}>
                                <p className={`set`}>Сет</p>
                                <p className={`title`}>&laquo;Настроение&raquo;</p>
                                <p className={`text`}>
                                    Стильный дуэт оттенков металла и&nbsp;геометрических форм. Изысканность
                                    и&nbsp;элегантность силуэтов. Украшения, которые отражают настроение
                                    лёгкости и&nbsp;свободы.
                                </p>
                                {collectionDetailedData.platinaSeven.length !== 0 && (
                                    <div className={`btn btn__default btn__platina-line`}
                                         onClick={() => this.setOpen('setSeven', 'setSevenRef')}>
                                        Украшения сета
                                        <Svg id={`arrows-right`} className={`svg__arrow-right-one`} />
                                    </div>
                                )}
                            </div>
                        </div>
                        {setSeven && (
                            <>
                                <div className={`cardAll cardAll__platinaLine`}
                                     ref={this.setSevenRef}>
                                    <div className={`cardAll__catalog`}>
                                        {dataSeven}
                                    </div>
                                </div>
                                {countSeven !== 0 && (
                                    <div className={`buttons buttons__showMore`}>
                                        <div className={`btn btn__showMore`}
                                             onClick={() => this.showMore('cardSevenListCount', 'cardSevenListCountAdd')}>
                                            {this.showMoreMessage(countSeven, 'cardSevenListCountAdd')}
                                        </div>
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </div>
        </section>
    }
}

export default withViewItemBatcher(useWithStore(Line));
